/**
 * @description Function sorts final exam assignments by date.
 * @param assignments | The final exam assignments to be sorted.
 * @returns {Array}
 */
export const sortFinalExamAssignments = (assignments) =>
  assignments.sort((a, b) => {
    // If either start date is null, compare ids.
    if (!a.starts_at || !b.starts_at) return a.id > b.id ? 1 : -1;
    const aDate = Date.parse(a.starts_at);
    const bDate = Date.parse(b.starts_at);
    return aDate > bDate ? 1 : -1;
  });
